import { lazy, memo, Suspense } from 'react';

import { ErrorBoundaryWithRetry } from '@/_components';

import { Layout } from './layout';
import { Loading } from './loading';
import type { EmergencyContactProps } from './types';

const Page = lazy(() => import('./emergency-contact-edit'));
const PagePreview = lazy(() => import('./emergency-contact-preview'));

function EmergencyContactInputBase(props: EmergencyContactProps) {
  const { isEdit } = props;

  return (
    <Layout>
      <ErrorBoundaryWithRetry>
        <Suspense fallback={<Loading />}>{isEdit ? <Page {...props} /> : <PagePreview {...props} />}</Suspense>
      </ErrorBoundaryWithRetry>
    </Layout>
  );
}

export const EmergencyContactInput = memo(EmergencyContactInputBase);
